import {
    CommentMentionInput,
    CommentMentionOptionGroups,
    ResourceActivityResourceType,
    ResourceComment,
} from '@/types';

import { apiClient } from '../http';

export type ResourceCommentListParams = {
    component?: string;
    includeResolved?: boolean;
};

export type ResourceCommentInput = {
    component?: string;
    message: string;
    mentions?: CommentMentionInput[];
    metadata?: Record<string, unknown>;
    parentId?: string;
};

export const resourceCommentService = {
    create: (resourceType: ResourceActivityResourceType, resourceId: string, input: ResourceCommentInput) =>
        apiClient.post<ResourceComment, ResourceCommentInput>(
            `/api/resource-comments/${resourceType}/${resourceId}`,
            input,
        ),
    delete: (resourceType: ResourceActivityResourceType, resourceId: string, commentId: string) =>
        apiClient.delete<ResourceComment>(`/api/resource-comments/${resourceType}/${resourceId}/${commentId}`),
    list: (resourceType: ResourceActivityResourceType, resourceId: string, params?: ResourceCommentListParams) =>
        apiClient.get<ResourceComment[], ResourceCommentListParams>(
            `/api/resource-comments/${resourceType}/${resourceId}`,
            {
                params,
            },
        ),
    mentionOptions: (
        resourceType: ResourceActivityResourceType,
        resourceId: string,
        query = '',
    ) =>
        apiClient.get<CommentMentionOptionGroups, { query: string }>(
            `/api/resource-comments/${resourceType}/${resourceId}/mention-options`,
            { params: { query } },
        ),
    update: (
        resourceType: ResourceActivityResourceType,
        resourceId: string,
        commentId: string,
        input: Partial<ResourceCommentInput> & { resolved?: boolean },
    ) =>
        apiClient.put<ResourceComment, Partial<ResourceCommentInput> & { resolved?: boolean }>(
            `/api/resource-comments/${resourceType}/${resourceId}/${commentId}`,
            input,
        ),
};
